import React from 'react';

const CustomerComponentLoadable = React.lazy(() => import('../CustomerComponent/Customer/index'));
const CustomerTableComponentLoadable = React.lazy(() => import('../CustomerComponent/CustomerTableComponent'))
const SubAccountDetailsComponentLoadable = React.lazy(() => import('./Customer/Sub-Account'))
export {
    CustomerTableComponentLoadable,
    CustomerComponentLoadable,
    SubAccountDetailsComponentLoadable
};

